module.exports = __webpack_public_path__ + "static/img/doc-kid-ranjana.3d6cded.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/About-pics/doc-kid-ranjana.jpg
// module id = SvNe
// module chunks = 0